export default __webpack_public_path__ + "static/FreightTextProBold-Regular-a300c4ac3dfe0192e9935f402525b214.woff";